import ErrorBoundaryHandler from '@carvana/stc-error-boundary';

import { recordError } from '../../../utilities/moMetrics/uiMetrics';
import ErrorDisplay from './ErrorDisplay';

type ErrorBoundaryProps = {
  children: JSX.Element;
};

const ErrorBoundary = ({ children }: ErrorBoundaryProps) => (
  <ErrorBoundaryHandler onError={recordError} ErrorPage={ErrorDisplay}>
    {children}
  </ErrorBoundaryHandler>
);

export default ErrorBoundary;
